module.exports = __webpack_public_path__ + "static/media/Booking-Payment-Confirm.70ec4e89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/booking/Booking-Payment-Confirm.png
// module id = 99
// module chunks = 0